import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import { TypedMemo } from '../../common/types';
import { platformMeta } from '../promote/platformMeta';
import { SerializedSocialChannel } from '../promote/types';
import { socialMessages as messages } from './socialMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialReconnectLinesProps {
  /** The channels that need a new sign-in. */
  channels: SerializedSocialChannel[];
  onOpenChannels: () => void;
}

/**
 * One warning line for each channel that is signed out, with "Reconnect in Connections". Social has
 * no connect control: the link opens Connections, the old Channels page (design navigation-v2 b 2c).
 */
const SocialReconnectLinesComponent: React.FC<SocialReconnectLinesProps> = ({ channels, onOpenChannels }) => {
  const intl = useIntl();
  if (channels.length === 0) {
    return null;
  }
  return (
    <>
      {channels.map((channel) => (
        <div key={channel.platform} className={styles.reconnectLine} role="alert">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <span>
            {intl.formatMessage(messages.reconnectWarning, {
              channel: platformMeta[channel.platform].name,
              date:
                channel.lastSyncedAt === null
                  ? '—'
                  : intl.formatDate(channel.lastSyncedAt, { day: 'numeric', month: 'short' }),
            })}
          </span>
          <button type="button" className={styles.reconnectLink} onClick={onOpenChannels}>
            {intl.formatMessage(messages.reconnectInConnections)}
          </button>
        </div>
      ))}
    </>
  );
};

export const SocialReconnectLines = TypedMemo(SocialReconnectLinesComponent);
